import React from "react";
import '../styles/style.css'


const Button = (props) => {

    const handleClick = () => {
        if(props.disabled)
            return;
        props.func();            
    }

    return(
        <div onClick={() => handleClick()} style={{...props.style, cursor: props.disabled ? 'wait' : 'pointer'}} id={props.id} className={`btn ${props.className || ''}`}>
            <p style={{ margin: 0, fontWeight: 'bold', textAlign: 'center', width: '100%' }}>{props.name}</p>
        </div>
    )

}

export default Button;